import{a as e}from"./chunk-XTOIL6MB.mjs";function t(i,r){let l=r.bcsToBytes(),a=new e(l);return i.deserialize(a)}export{t as a};
//# sourceMappingURL=chunk-4YLUM62M.mjs.map